<template>
    <div id="trunk">
        <lead/>
        <main class="main">
            <router-view />
        </main>
        <foote/>
    </div>
</template>
<script>
import lead from "./head";
import foote from "@/components/common/footer";
export default {
    data() {
        return {

        };
    },
    created() { },
    mounted(){},
    methods: {},
    components: {
        lead,
        foote
    }
};
</script>
<style lang="scss">
.main {
    box-sizing: border-box;
    min-height: calc(100vh - 124px);
    padding: 25px 0 40px;
}
.course-menunav a {
    display: block;
    line-height: 65px;
}
     @import  './../../../assets/css/prepare.scss'
</style>